import { using, } from "rxjs";
export function refCountOn(scheduler) {
    return (source) => {
        const connectable = source;
        let count = 0;
        let subscription = null;
        return using(() => {
            ++count;
            scheduler.schedule(() => {
                if (!subscription && count > 0) {
                    subscription = connectable.connect();
                }
            });
            return {
                unsubscribe: () => {
                    --count;
                    scheduler.schedule(() => {
                        if (subscription && count === 0) {
                            subscription.unsubscribe();
                            subscription = null;
                        }
                    });
                },
            };
        }, () => source);
    };
}
//# sourceMappingURL=refCountOn.js.map